module.exports = __webpack_public_path__ + "static/media/logo.70b663f7.svg";